import React, { createContext, useContext, useEffect, useState } from 'react';

interface CsrfContextValue {
  csrfToken: string | null;
}

const CsrfContext = createContext<CsrfContextValue | undefined>(undefined);

let storedToken: string | null = null;

export const getCsrfToken = () => storedToken;

export const CsrfProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [csrfToken, setCsrfToken] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/csrf')
      .then(res => res.json())
      .then(data => {
        setCsrfToken(data.token);
        storedToken = data.token;
      });
  }, []);

  return React.createElement(
    CsrfContext.Provider,
    { value: { csrfToken } },
    children
  );
};

export const useCsrf = () => {
  const context = useContext(CsrfContext);
  if (!context) throw new Error('useCsrf must be used within a CsrfProvider');
  return context;
};